import { ChangeDetectorRef, Component, ChangeDetectionStrategy } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subscription } from "rxjs";
import { doc2Model } from "../../api.service";
import { getApp } from "../../app";
import { Impact } from "../../../../../shared/models/impact";
import { Responsibles } from "../../../../../shared/models/responsibles";

export const RED = "red";
export const GREEN = "green";

@Component({
    selector: "app-wf-automation",
    templateUrl: "./wf-automation.component.html",
    styleUrls: ["./wf-automation.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WorkflowAutomationComponent {
  impactId = "";
  currentResponsible = "";
  saveDisabled = false;
  size = 0;
  departments = departments;
  selected = new Set<string>();
  red = RED;
  green = GREEN;
  view: "discardChanges" | "detailView" | "delete" = "detailView";

  private _sizeSubscription: Subscription = new Subscription();

  app = getApp((app) => {
    this.app = app;
  });

  constructor(
    private modalService: NgbModal,
    private _cdRef: ChangeDetectorRef
  ) {}

  async ngOnInit() {
    await this.createModel();

    this.app.type = "impact";

    this._sizeSubscription = this.app.impact.newInvalidField.subscribe(
      (value: any) => {
        if (this.size !== value) {
          this.size = value;
          this.saveDisabled = this.isDisabled();
          this._cdRef.detectChanges();
        }
      }
    );
  }

  async createModel() {
    if (this.app.state.impactId) {
      this.impactId = this.app.state.impactId;
      await this.app.impact.getImpactById(this.impactId);
      this.app.model = this.app.impact.currentImpact;
    } else {
      const impactModel: any = doc2Model("impact", new Impact());
      this.app.impact.currentImpact = impactModel;
      this.app.state.createMode = true;
      this.app.impact.currentImpact["impact.responsibles"] = doc2Model(
        "responsibles",
        new Responsibles()
      );
    }
    this.app.type = "impact";
    this.app.model = {};
  }

  display(field: string) {
    if (
      this.app.impact.currentImpact &&
      this.app.impact.currentImpact["impact.responsibles"] != null &&
      this.app.impact.currentImpact["impact.responsibles"][field] != null
    ) {
      if (this.app.impact.currentImpact["impact.responsibles"][field] !== "") {
        return true;
      } else {
        return false;
      }
    }
  }

  hasDifferentDisplay(department: string) {
    switch (department) {
      case "Cargo":
        if (this.app.thread.thread["thread.omfStatus"] === "90") {
          return true;
        }
        break;
      default:
        return false;
    }
  }

  async discardChanges() {
    this.app.impact.id = this.app.impact.id;
    this.app.unlockedId = null;
    if (this.app.impact.isNew) {
      this.app.impact.id = null;
    }
    await this.createModel();
    this.app.model = {};
    this.app.typeAheadBasic.model = {};
    this.app.field.inputSubject.next(true);
    this.app.state.createMode = false;
  }

  async save() {
    await this.app.impact.save();
    this.app.typeAheadBasic.model = {};
     this.app.state.createMode = false;
    this.modalService.dismissAll();
  }

  hasInvalidFields() {
    if (
      this.app.field.getInvalidFields("impact", this.app.impact.currentImpact)
        .length < 1 &&
      this.app.impact.modelHasChanges
    ) {
      return false;
    } else {
      return true;
    }
  }

  isDisabled() {
    if (this.size === 0) {
      return false;
    } else {
      return true;
    }
  }

  async deleteImpact() {
    await this.app.impact.delete(this.app.impact.currentImpact);
    this.modalService.dismissAll();
  }

  ngOnDestroy(): void {
    // The modal can be closed without save/discard, createMode must not leak into other views
    this.app.state.createMode = false;
    if (this._sizeSubscription) {
      this._sizeSubscription.unsubscribe();
    }
  }
}

export const departments = [
  {
    name: "Fernverkehr",
    fields: {
      bav: "responsibles.bavFv",
      bavVertreter: "responsibles.bavFvVertreter",
      bavVertreter2: "responsibles.bavFvVertreter2",
      mawi: "responsibles.mawiFv",
      mawiVertreter: "responsibles.mawiFvVertreter",
      mawiVertreter2: "responsibles.mawiFvVertreter2",
    },
  },
  {
    name: "Regio",
    fields: {
      bav: "responsibles.bavRegio",
      bavVertreter: "responsibles.bavRegioVertreter",
      bavVertreter2: "responsibles.bavRegioVertreter2",
      mawi: "responsibles.mawiRegio",
      mawiVertreter: "responsibles.mawiRegioVertreter",
      mawiVertreter2: "responsibles.mawiRegioVertreter2",
    },
  },
  {
    name: "Cargo",
    fields: {
      bav: "responsibles.bavCargo",
      bavVertreter: "responsibles.bavCargoVertreter",
      bavVertreter2: "responsibles.bavCargoVertreter2",
      mawi: "responsibles.mawiCargo",
      mawiVertreter: "responsibles.mawiCargoVertreter",
      mawiVertreter2: "responsibles.mawiCargoVertreter2",
    },
  },
  {
    name: "FZI",
    fields: {
      bav: "responsibles.bavFzi",
      bavVertreter: "responsibles.bavFziVertreter",
      bavVertreter2: "responsibles.bavFziVertreter2",
      mawi: "responsibles.mawiFzi",
      mawiVertreter: "responsibles.mawiFziVertreter",
      mawiVertreter2: "responsibles.mawiFziVertreter2",
    },
  },
  {
    name: "Sonstige",
    fields: {
      bav: "responsibles.bavNetz",
      bavVertreter: "responsibles.bavNetzVertreter",
      bavVertreter2: "responsibles.bavNetzVertreter2",
      mawi: "responsibles.mawiNetz",
      mawiVertreter: "responsibles.mawiNetzVertreter",
      mawiVertreter2: "responsibles.mawiNetzVertreter2",
    },
  },
];
